import React from 'react'
import ReactDOM from 'react-dom'
import { compose } from 'recompose'
import { Modal, Button, Spin, Icon, message } from 'antd'
import { injectIntl, FormattedMessage } from 'react-intl'
import _get from 'lodash/get'
import moment from 'moment'
import useOmiseOffline from '~/App/hooks/useOmiseOffline'
import { Block } from '../styles'

const showTescoBarcode = ({ $slip }) => {
  const w = window.open()
  ReactDOM.render($slip, w.document.body)
  // w.addEventListener('load', function () {
  //   window.alert('loaded')
  //   w.alert('loaded 2')
  // }, true)
  // w.setTimeout(() => {
  //   w.focus()
  //   w.print()
  //   w.close()
  // }, 1000)
}

const OmiseTesco = compose(
  injectIntl
)(({ intl, registration, discounted, gatewayRate, gatewaySettings, systemFee, totalSystemFee, itemsDiscounted }) => {
  const publicKey = _get(gatewaySettings, 'publicKey', process.env.REACT_APP_OMISE_PUBLIC_KEY) || process.env.REACT_APP_OMISE_PUBLIC_KEY
  const totalAmount = discounted + itemsDiscounted
  const fee = Math.round(gatewayRate * discounted * 100) / 100
  const finalAmount = totalAmount + fee

  const [omiseLoaded, paymentLoading, pay] = useOmiseOffline('omise_tesco', publicKey, (err) => {
    const { graphQLErrors } = err
    if (graphQLErrors) {
      graphQLErrors.forEach(error => {
        message.error(intl.formatMessage({ id: `api.${error.message}` }))
      })
    } else if (err.message) {
      message.error(err.message)
    } else {
      message.error(err)
    }
  })

  const handleCheckout = async () => {
    const references = await pay('bill_payment_tesco_lotus', registration, {
      amount: finalAmount
    })

    const eventName = _get(registration, 'event.name.th')
    if (references) {
      const expiresAt = moment(references.expires_at)
        .format('lll')
      const $slip = <div className="tescoSlipWrapper">
        <div className="tescoSlip">
          <div style={{ color: 'red' }}>***{intl.formatMessage({ id: `paymentMethod.tescoWarning` })}</div>
          <div><img id="tescoBarcode" src={references.barcode} style={{ width: '100%' }} alt='Barcode' /></div>
          <h3>{eventName}</h3>
          <div>ชำระที่ {intl.formatMessage({ id: `paymentMethod.omise_tesco` })}</div>
          <div>
            {intl.formatMessage(
              { id: `app.payBaht` },
              { amount: intl.formatNumber(finalAmount) }
            )}
          </div>
          <div>rid: {registration._id}</div>
          <div>ref1: {references.reference_number_1}</div>
          <div>ref2: {references.reference_number_2}</div>
          <div>{intl.formatMessage({ id: `paymentMethod.expiry` })}: {expiresAt}</div>
        </div>
      </div>
      Modal.confirm({
        style: { top: 0 },
        className: 'tescoModal',
        content: $slip,
        okText: [<Icon type="printer" />, intl.formatMessage({ id: `app.print` })],
        onOk () {
          showTescoBarcode({ $slip })
        }
      })
    }
  }

  return <Block>
    {omiseLoaded ? <React.Fragment>
      <div className="title">
        <FormattedMessage id="paymentMethod.omise_tesco" />
      </div>
      <div style={{ color: 'red' }}>***<FormattedMessage id="paymentMethod.tescoWarning" /></div>
      <div>
        {systemFee
          ? <React.Fragment>
            <FormattedMessage id="app.entryFeeBaht" defaultMessage="Entry Fee {amount} Baht" tagName="div" values={{
              amount: intl.formatNumber(discounted - totalSystemFee)
            }} />
            <FormattedMessage id="app.processingFeeBaht" defaultMessage="Processing Fee {amount} Baht" tagName="div" values={{
              amount: intl.formatNumber(totalSystemFee)
            }} />
          </React.Fragment>
          : <FormattedMessage id="app.entryFeeBaht" defaultMessage="Entry Fee {amount} Baht" tagName="div" values={{
            amount: intl.formatNumber(discounted)
          }} />
        }
        <FormattedMessage id="app.paymentProcessingFeeBaht" defaultMessage="Processing Fee" values={{
          amount: intl.formatNumber(fee)
        }} />
        {itemsDiscounted > 0 && <FormattedMessage id="app.itemsAmountBaht" defaultMessage="Extra Products {amount} Baht" tagName="div" values={{
          amount: intl.formatNumber(itemsDiscounted)
        }} />}
      </div>
      <div>
        <FormattedMessage id="app.processingFeeTesco" defaultMessage="Processing Fee" />
      </div>
      <Button
        icon="barcode"
        type="primary"
        onClick={handleCheckout}
        loading={paymentLoading}
        className="paymentButton"
      >
        <FormattedMessage id="paymentMethod.showBarcode" />
      </Button>
    </React.Fragment>
      : <div className="modLoadding">
        <Spin tip="Loading..." size="large" />
      </div>}
  </Block>
})

export default OmiseTesco



// WEBPACK FOOTER //
// ./src/App/components/PaymentBlocks/OmiseTesco/OmiseTesco.js